import SubscribeApi from './subscribe-api';

export default SubscribeApi;
